import Sortable from 'sortablejs';

document.addEventListener('DOMContentLoaded', () => {
  initSortables();
});

export function initSortables() {
  const sortableItems = document.querySelectorAll('[data-sortable]');

  sortableItems.forEach((sortableItem) => {
    Sortable.create(sortableItem, {
      handle: '.handle'
    })
  });
}


let dotnetRef;
export function initTreeReorder(dotnetRefParam: any) {
  dotnetRef = dotnetRefParam;

  const lists = Array.from(document.querySelectorAll('ul.tree-explorer, ul.tree-branch')) as HTMLElement[];

  lists.forEach((list) => {
    Sortable.create(list, {
      handle: 'li',
      animation: 150,
      fallbackOnBody: true,
      swapThreshold: 0.65,
      onEnd: (evt) => {
        try {
          const itemEl = evt.item as HTMLElement;
          const id = itemEl.dataset.id;
          const kind = itemEl.dataset.kind;
          const newSequence = evt.newIndex;
          if (!id || !kind) return;
          dotnetRef.invokeMethodAsync('OnItemReordered', kind, id, newSequence);
        } catch (err) {
          console.error('initTreeReorder onEnd error', err);
        }
      }
    });

  });
}
